import React, { useState, useEffect } from "react";
import { Modal, TextInput, Button, Group, Select } from "@mantine/core";
import classes from "./edit.module.css";
import { RowDataNotification } from "./types";

type NotificationType = "Type 1" | "Type 2" | "Type 3";

interface EditNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEditNotification: (editedNotificationData: RowDataNotification) => void;
  notificationData: RowDataNotification;
}
const EditNotificationModal: React.FC<EditNotificationModalProps> = ({
  isOpen,
  onClose,
  onEditNotification,
  notificationData,
}) => {
  const [editedNotification, setEditedNotification] =
    useState<RowDataNotification>(notificationData);

    useEffect(() => {
        setEditedNotification(notificationData);
    }, [notificationData, isOpen]);
 
  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditedNotification({
      ...editedNotification,
      title: event.currentTarget.value,
    });
  };

  const handleBodyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditedNotification({
      ...editedNotification,
      body: event.currentTarget.value,
    });
  };

  const handleTypeChange = (value: string | null) => {
    if (value) {
      setEditedNotification({
        ...editedNotification,
        type: value as NotificationType,
      });
    }
  };

  const handleEdit = () => {
    // Check if any required fields are empty
    if (
        !editedNotification.title ||
        !editedNotification.body ||
      //   newNotification.type === ""
      !editedNotification.route
      ) {
        alert("Please fill in all the required fields");
        return;
      }
    onEditNotification(editedNotification);
    // console.error(editedNotification)

    onClose();
  };



  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Notification
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <div className={classes.spacing}>
        <TextInput
          label="Title"
          maxLength={255}
          value={editedNotification.title}
          onChange={handleTitleChange}
        />

        <TextInput
          label="Body"
          maxLength={255}
          value={editedNotification.body}
          onChange={handleBodyChange}
        />

        <Select
            label="Route"
            placeholder="Select route"
            required
            defaultValue={'Home'}
            value={editedNotification.route}
            data={[
                { value: 'Home', label: 'Home' },

                { value: 'ViewnetCash', label: 'ViewnetCash' },
                { value: 'MyQR', label: 'MyQR' },
                { value: 'Rewards', label: 'Rewards' },
                { value: 'Me', label: 'Me' },

                { value: 'Membership', label: 'Membership' },
                { value: 'MyVouchers', label: 'MyVouchers' },
                { value: 'MyPurchases', label: 'MyPurchases' },
                { value: 'FAQ', label: 'FAQ' },
                { value: 'TermsOfUse', label: 'TermsOfUse' },
                { value: 'PrivacyPolicy', label: 'PrivacyPolicy' },
                { value: 'PriceList', label: 'PriceList' },
                { value: 'DailyFeed', label: 'DailyFeed' },
                { value: 'MyMerchandise', label: 'MyMerchandise' },

                { value: 'CashHistory', label: 'CashHistory' },
                { value: 'CoinHistory', label: 'CoinHistory' },

                { value: 'Notification', label: 'Notification' },
            ]}
            onChange={(value, option) =>
                setEditedNotification({ ...editedNotification, route: value })
            }
        />

        <Group className={classes.buttonBottom}>
          <Button onClick={onClose} className={classes.buttonCancel}>
            Back
          </Button>
          <Button onClick={handleEdit} className={classes.buttonSaveChanges}>
            Save Changes
          </Button>
        </Group>
      </div>
    </Modal>
  );
};

export default EditNotificationModal;
